(function ( $ ) {
     $.fn.acordion = function (options) {
         var settings = $.extend({
            someOption: ""
        }, options);

        var objLink    = $(this);
        var opened     = false;

        function _init() {
            $( objLink ).click(function() {
                if($(this).closest('.accordion').hasClass('active')){
                    $(this).closest('.accordion').removeClass('active');
                    $(this).html($(this).attr('data-default'));
                }else{
                    //$(".accordion").removeClass('active');
                    $(this).html($(this).attr('data-close'));
                    $(this).closest('.accordion').addClass('active');
                }

            });
        }

        _init();

       return {
         reload:_init,
       };
    };
}( jQuery ));

$(".accordion .accordion-title a").acordion();
